import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Box, Typography } from "@mui/material";
import { HStack } from "Components/_Shared/Core/Stack";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import type { FC } from "react";

type EvaluationMessageProps = {
  severity: "error" | "warning";
  title: string;
};

const EvaluationMessage: FC<EvaluationMessageProps> = ({ severity, title }) => (
  <HStack alignItems="center" gap={Spacing.S}>
    <WarningAmberIcon sx={{ color: `${severity}.main`, fontSize: "18px" }} />
    <Box>
      <Typography variant="caption" color={`${severity}.main`} fontWeight={600}>
        {title}
      </Typography>
    </Box>
  </HStack>
);

type Props = {
  isEvaluationPending: boolean;
  hasEvaluationWarning: boolean;
  hasEvaluationError: boolean;
  noQuestionnaireEvaluation: boolean;
};

export const GoalFulfillmentSolutionItemWarning: FC<Props> = ({
  isEvaluationPending,
  hasEvaluationWarning,
  hasEvaluationError,
  noQuestionnaireEvaluation,
}) => {
  const { t } = useResource();

  if (isEvaluationPending) return null;

  return (
    <>
      {hasEvaluationWarning && (
        <EvaluationMessage severity="error" title={t(Resources.AnalysisDetail.GoalsFulfillment.Nsure.Evaluation.WarningAlertTitle)} />
      )}
      {hasEvaluationError && (
        <EvaluationMessage severity="error" title={t(Resources.AnalysisDetail.GoalsFulfillment.Nsure.Evaluation.EvaluationFailedTitle)} />
      )}
      {noQuestionnaireEvaluation && (
        <EvaluationMessage
          severity="warning"
          title={t(Resources.AnalysisDetail.GoalsFulfillment.Nsure.Evaluation.MissingQuestionnaireTitle)}
        />
      )}
    </>
  );
};
